<img alt="Meteogram" [matTooltip]="tooltip" [matTooltipDisabled]="isMobile" [src]="src" />
